import { DataLayer } from './datalayer.types';
import { useDataLayerEventGeneric, useDataLayerEventPage } from './hooks';

export const useDatalayer: DataLayer = () => {
  const pageView = useDataLayerEventPage();
  const genericEvent = useDataLayerEventGeneric();

  return {
    pageView,
    genericEvent,
  };
};
